export default __webpack_public_path__ + "static/media/Dollar-Bill-Yall-Badge.3e33c57f.gif";